import { createFileRoute, redirect } from '@tanstack/react-router';
import { ContestFormPage } from '../pages/contests/contest-form-page';
import { isAuthenticated } from '../auth/session';

export const Route = createFileRoute('/contests/new')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
  },
  component: ContestFormPage,
});
